'use client'
import { useEffect, useRef } from 'react'
import { RaButton } from '@components/core/index.core'
import { ICONS } from '@constants/icons.constants'

import { useUi } from '@contexts/ui.context'
import { useOutsideClick } from '@utilities/hooks/useOutsideClick.hooks'

import styles from './ra-lightbox.module.scss'

export const RaLightbox = () => {
  const dialogRef = useRef(null)
  const { lightbox, closeLightbox } = useUi()

  const handleClose = () => closeLightbox()

  useEffect(() => {
    if (lightbox.isOpen && dialogRef.current) {
      dialogRef.current.showModal()
    } else {
      dialogRef.current.close()
    }
  }, [lightbox.isOpen])

  const contentRef = useOutsideClick(() => {
    lightbox.isOpen && handleClose()
  })

  return (
    <dialog
      ref={dialogRef}
      className={styles['ra-lightbox']}>
      <div
        ref={contentRef}
        className={styles['ra-lightbox__content']}>
        <div className={styles['ra-lightbox__close']}>
          <RaButton
            variant="icon"
            icon={ICONS.CLOSE_ICON}
            textColor="dark"
            onClick={handleClose}
          />
        </div>
        {lightbox.content}
      </div>
    </dialog>
  )
}
